import { CompassCardUI } from '@scale/compass-ui/types';
import {
  TagUntagUsersCardShared,
  type TagUntagUsersContextSchemaType,
  type TagUntagUsersContext,
  TAG_UNTAG_USERS,
} from '@scale/genai-compass-shared/cards/tag_untag_users';
import { faUserTag } from '@fortawesome/pro-solid-svg-icons';
import TagUntagUsersCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/TagUntagUsersCard/TagUntagUsersCardComponent';

const defaultContext: TagUntagUsersContext = {
  cardType: TAG_UNTAG_USERS,
  userIdColumn: '',
  tagIdColumn: '',
  actionColumn: '',
};

export const TagUntagUsersCardInfo: CompassCardUI<TagUntagUsersContextSchemaType> = {
  ...TagUntagUsersCardShared,
  title: 'Tag/Untag Users',
  icon: 'user-tag',
  toolTip: 'Tag or untag users based on per-row userId, tagId, and action columns.',
  defaultContext,
  showOutput: true,
  button: {
    icon: faUserTag,
  },
  component: TagUntagUsersCardComponent,
};
